module.exports = __webpack_public_path__ + "fonts/WorkSans-ExtraBold.27dab2e.eot";